import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  dismissAllNewApplicants,
  dismissNewApplicant,
} from '@company/services/application/api';
import QueryKeys from '@constants/queryKeys';

const useInvalidateCandidates = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.JobDetail.CANDIDATES],
    });
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.JobDetail.CANDIDATE_COUNTERS],
    });
  };
};

export function useDismissNewApplicant() {
  const invalidate = useInvalidateCandidates();
  return useMutation({
    mutationFn: ({
      jobId,
      jobAssignmentId,
    }: {
      jobId: number;
      jobAssignmentId: number;
    }) => dismissNewApplicant(jobId, jobAssignmentId),
    onSuccess: invalidate,
  });
}

export function useDismissAllNewApplicants() {
  const invalidate = useInvalidateCandidates();
  return useMutation({
    mutationFn: (jobId: number) => dismissAllNewApplicants(jobId),
    onSuccess: invalidate,
  });
}
